import { publish } from '../utils/pubsub';
import SystemSocket from './SystemSocket';

import logService from './logService3';

import config from '../../config.json';
import reconnectManager from '../ReconnectManager';

let _isStarting = false;

const _gatewayStream = config.gatewayStreamName;

const _name = 'SystemStreamer';
class SystemStreamer {
    start = async () => {
        if (this._connection !== undefined && this._connection !== null) {
            return true;
        }

        logService.log(`${_name}.init: initializing`);

        try {
            this._socket = new SystemSocket();

            this._connection = await this._socket.init(`${_gatewayStream}`, this.handleSocketError, this.handleStateChanged);
            if (this._connection === null) {
                // error connecting to portal
                await this.stop();
                return false;
            }

            this._token = this._socket.subscribeTo('PublicPublications', this._connection, this.handleDataReceived);
            this._isInitialized = this._token !== undefined;

            return true;
        } catch (error) {
            logService.logError(`${_name}.start: ${error.message}`);
            await this.stop();
            return false;
        }
    };

    stop = async () => {
        try {
            if (this._token !== null && this._token !== undefined) {
                this._token.dispose();
                this._token = undefined;
            }

            if (this._connection !== undefined && this._connection !== null) {
                // await this.send('stopping');
                await this._connection.stop();
                this._connection = undefined;
            }

            this._isInitialized = this._token === undefined;
            // this._isInitialized = this._connection === undefined;

            return true;
        } catch (error) {
            logService.logError(`${_name}.stop: ex=${error.message}`);
            return false;
        }
    };

    send = async (msg) => {
        try {
            if (this._connection === undefined || this._connection === null || this._connection._connectionState === 'Disconnected') {
                // logService.logError(`${_name}.send: _connection == null, msg=${msg}`);
                // await this.start();
            }

            if (this._connection !== undefined) {
                await this._connection.invoke('send', msg);
            }
        } catch (ex) {
            logService.logError(`${_name}.send: ex=${ex}`);
        }
    };

    handleSocketError = async (p) => {
        publish('SystemSocketError', p);

        await this.stop();

        // start reconnect manager
        reconnectManager.schedule(); // ADDED
    };

    handleStateChanged = (p) => {
        let connected = false;

        if (p === 'Disconnected') connected = false;
        if (p === 'Connected') connected = true;

        // events.publish('SystemSocketStateChanged', connected);
        publish(`SystemSocketStateChanged`, connected);
    };

    handleDataReceived = (p) => {
        // publish received socket to every one
        // publisher.pubEvent('SystemSocketDataReceived', p);
        publish('SystemSocketDataReceived', p);
    };

    get isInitialized() {
        return this._isInitialized;
    }

    get isConnected() {
        if (this._connection === undefined || this._connection === null) {
            return false;
        }
        if (this._connection._connectionState === 'Connected') {
            return true;
        }
        return false;
    }
}

const systemStreamer = new SystemStreamer();
export default systemStreamer;
